import { render, staticRenderFns } from "./Goodsmx.vue?vue&type=template&id=157cb1a0&scoped=true"
import script from "./Goodsmx.vue?vue&type=script&lang=js"
export * from "./Goodsmx.vue?vue&type=script&lang=js"
import style0 from "./Goodsmx.vue?vue&type=style&index=0&id=157cb1a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157cb1a0",
  null
  
)

export default component.exports